/**
 * mt-mdnmd-product.js
 * Product detail page interaction logic
 * Configuration is passed through the inline  <script type="application/json" data-mt-mdnmd-config>  input
 */

(function () {
  'use strict';

  const sizeOrder = 'CXXS CXS CS CM CL CXL CXXL CXXXL CHILDXS CHILDS CHILDM CHILDL CHILDXL AXXS AXS AS AM AL AXL AXXL AXXXL XXS XS S M L XL XXL XXXL'.split(' ');
  function sizeRank(value) {
    const key = value.trim().toUpperCase().replace(/[\s-]/g, '').replace('2XL', 'XXL').replace('3XL', 'XXXL');
    const index = sizeOrder.indexOf(key);
    return index < 0 ? sizeOrder.length : index;
  }
  function stockLimit(variant, inventory) {
    const stock = variant && inventory[String(variant.id)];
    if (!stock || !stock.managed || stock.policy === 'continue') return Infinity;
    return Math.max(0, Number(stock.quantity) || 0);
  }

  /* =====================================================
     Utility functions
     ===================================================== */

  /** Format price (in cents) */
  function fmtMoney(cents) {
    const dollars = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + dollars;
  }

  /* =====================================================
     Initialization entry point —— Support multiple instances (multiple on one page  section）
     ===================================================== */

  function initInstance(configEl) {
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[mt-mdnmd] Failed to parse config', e);
      return;
    }

    const sectionId      = config.sectionId;
    let variantsData   = config.variants || [];
    let inventory = config.inventory || {};
    const storefrontToken = config.storefrontToken || '';

    const root = document.getElementById('mt-mdnmd-product-' + sectionId);
    if (!root || configEl.dataset.initialized) return;
    configEl.dataset.initialized = 'true';
    const routeRoot = (window.Shopify && window.Shopify.routes.root) || '/';
    let busy = false;
    let lastVariantId;
    const stockMessage = root.querySelector('[data-stock-message]');
    const errorMessage = root.querySelector('[data-purchase-error]');
    const quantityInput = root.querySelector('.mt-mdnmd-pd__qty-input');
    root.querySelectorAll('.mt-mdnmd-pd__size-btns').forEach(function (container) {
      Array.from(container.children).sort(function (a, b) {
        const av = a.querySelector('input').value;
        const bv = b.querySelector('input').value;
        return sizeRank(av) - sizeRank(bv) || av.localeCompare(bv, undefined, { numeric: true });
      }).forEach(function (label) { container.appendChild(label); });
    });

    /* --------------------------------------------------
       Mobile image carousel
       -------------------------------------------------- */
    const mobMain   = root.querySelector('#mt-mob-main-' + sectionId);
    const mobThumbs = root.querySelector('#mt-mob-thumbs-' + sectionId);
    const mobSlides = mobMain ? Array.from(mobMain.querySelectorAll('.mt-mdnmd-pd__mob-slide')) : [];
    let currentIdx  = 0;

    function goTo(idx) {
      idx = Math.max(0, Math.min(mobSlides.length - 1, idx));
      currentIdx = idx;

      // Switch slides
      mobSlides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
      });

      // Synchronize mobile thumbnail highlighting
      if (mobThumbs) {
        var thumbs = mobThumbs.querySelectorAll('[data-index]');
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.dataset.index) === idx);
        });
        var active = mobThumbs.querySelector('.is-active');
        if (active) {
          // Scroll the thumbnail container manually to avoid  scrollIntoView  shifting the entire page
          var container = mobThumbs;
          var thumbLeft = active.offsetLeft;
          var thumbRight = thumbLeft + active.offsetWidth;
          var containerLeft = container.scrollLeft;
          var containerRight = containerLeft + container.clientWidth;
          if (thumbRight > containerRight) {
            container.scrollTo({ left: thumbRight - container.clientWidth + 16, behavior: 'smooth' });
          } else if (thumbLeft < containerLeft) {
            container.scrollTo({ left: thumbLeft - 16, behavior: 'smooth' });
          }
        }
      }
    }

    // Mobile thumbnail click
    if (mobThumbs) {
      mobThumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-index]');
        if (btn) goTo(parseInt(btn.dataset.index));
      });
    }

    // Mobile touch swipe
    var touchStartX = 0;
    if (mobMain) {
      mobMain.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      mobMain.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(currentIdx + (diff > 0 ? 1 : -1));
      }, { passive: true });
    }

    /* --------------------------------------------------
       Quantity +/-
       -------------------------------------------------- */
    var buyWrap = root.querySelector('.mt-mdnmd-pd__buy-wrap');
    if (buyWrap) {
      buyWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.mt-mdnmd-pd__qty-btn');
        if (!btn) return;
        var input = buyWrap.querySelector('.mt-mdnmd-pd__qty-input');
        if (!input) return;
        var dir = parseInt(btn.dataset.dir || '0');
        input.value = Math.min(Number(input.max) || Infinity, Math.max(1, (parseInt(input.value || '1') || 1) + dir));
      });
    }

    /* --------------------------------------------------
       Variant switching (color /  + size)
       -------------------------------------------------- */
    var variantIdEl = root.querySelector('.mt-mdnmd-product-variant-id');
    var colorLabel  = root.querySelector('[data-color-label]');
    var sizeLabel   = root.querySelector('[data-size-label]');
    var priceEl     = root.querySelector('.mt-mdnmd-pd__price');

    function findVariant() {
      const selected = Array.from(root.querySelectorAll('.mt-mdnmd-pd__color-input:checked, .mt-mdnmd-pd__size-input:checked'));
      const previous = variantsData.find(v => String(v.id) === String(variantIdEl && variantIdEl.value)) || variantsData[0];
      return variantsData.find(function (v) {
        return [1, 2, 3].every(function (position) {
          const input = selected.find(el => Number(el.dataset.colorPos || el.dataset.sizePos) === position);
          return v['option' + position] === (input ? input.value : previous && previous['option' + position]);
        });
      });
    }

    function showError(message) {
      if (errorMessage) { errorMessage.textContent = message; errorMessage.hidden = !message; }
    }

    function syncPurchaseUI(v) {
      const limit = stockLimit(v, inventory);
      const available = Boolean(v && v.available && limit > 0);
      if (variantIdEl) variantIdEl.value = v ? v.id : '';
      if (quantityInput) {
        if (Number.isFinite(limit)) quantityInput.max = String(Math.max(1, limit));
        else quantityInput.removeAttribute('max');
      }
      [addBtn, buyBtn].forEach(function (button) {
        if (!button) return;
        button.disabled = busy || !available;
        button.setAttribute('aria-disabled', String(button.disabled));
        button.textContent = !v ? 'Unavailable' : !available ? 'Sold out' : busy ? 'Please wait…' : button.dataset.availableLabel;
      });
      if (stockMessage) {
        stockMessage.textContent = !v ? 'This combination is unavailable.' : !available ? 'Sold out' :
          limit <= Number(config.lowStockThreshold || 5) ? 'Only ' + limit + ' left' : '';
        stockMessage.hidden = !stockMessage.textContent;
      }
      const color = root.querySelector('.mt-mdnmd-pd__color-input:checked');
      root.querySelectorAll('.mt-mdnmd-pd__size-input').forEach(function (input) {
        const availableSize = variantsData.some(function (candidate) {
          return candidate['option' + input.dataset.sizePos] === input.value &&
            (!color || candidate['option' + color.dataset.colorPos] === color.value) &&
            candidate.available && stockLimit(candidate, inventory) > 0;
        });
        input.disabled = !availableSize;
        input.closest('label').classList.toggle('is-unavailable', !availableSize);
      });
    }

    function updateVariantUI() {
      var v = findVariant();
      if (lastVariantId !== (v && v.id)) showError('');
      lastVariantId = v && v.id;
      syncPurchaseUI(v);
      if (!v) return;

      // Update hidden  variant ID
      if (variantIdEl) variantIdEl.value = v.id;

      // Update price
      if (priceEl) {
        var saleEl    = priceEl.querySelector('.mt-mdnmd-pd__price-sale');
        var compareEl = priceEl.querySelector('.mt-mdnmd-pd__price-compare');
        if (saleEl) saleEl.textContent = fmtMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price > v.price) {
            compareEl.textContent = fmtMoney(v.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }

      // Mobile: switch to the variant's associated image
      if (v.featured_image && mobSlides.length) {
        var featSrc = v.featured_image.src || '';
        // Extract the core filename (remove size suffix and query parameters)
        var fname = featSrc.split('?')[0].split('/').pop()
          .replace(/(_\d+x\d*)?(\.(jpg|jpeg|png|webp|gif))$/i, '');
        var idx = mobSlides.findIndex(function (el) {
          var img = el.querySelector('img');
          return img && img.src && img.src.indexOf(fname) !== -1;
        });
        if (idx >= 0) goTo(idx);
      }
    }

    root.querySelectorAll('.mt-mdnmd-pd__color-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (colorLabel) colorLabel.textContent = input.value;
        updateVariantUI();
      });
    });

    root.querySelectorAll('.mt-mdnmd-pd__size-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (sizeLabel) sizeLabel.textContent = input.value;
        updateVariantUI();
      });
    });

    /* --------------------------------------------------
       Add to cart / Buy Now
       -------------------------------------------------- */
    var form   = root.querySelector('form[data-type="add-to-cart-form"]');
    var addBtn = root.querySelector('.mt-mdnmd-pd__btn--cart');
    var buyBtn = root.querySelector('[data-mt-buy]');

    [addBtn, buyBtn].forEach(function (button) {
      if (button) button.dataset.availableLabel = button.textContent.trim();
    });
    updateVariantUI();

    async function purchase(checkout) {
      if (busy) return;
      let variant = findVariant();
      if (!variant || !variant.available || stockLimit(variant, inventory) <= 0) {
        syncPurchaseUI(variant);
        showError('Please select an available size and color.');
        return;
      }
      const qty = Number(quantityInput ? quantityInput.value : 1);
      if (!Number.isInteger(qty) || qty < 1) { showError('Enter a whole quantity of at least 1.'); return; }
      const id = variant.id;
      // Preserve app-added product properties and selling plans for Add to Cart.
      const data = new FormData(form);
      data.set('id', String(id));
      data.set('quantity', String(qty));
      busy = true;
      showError('');
      syncPurchaseUI(variant);
      try {
        // Read fresh Liquid inventory before purchasing; cached page counts can be stale.
        const url = new URL(config.productUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('variant', id);
        const response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Unable to check availability. Please try again.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const freshEl = doc.querySelector('[data-mt-mdnmd-config]');
        if (!freshEl) throw new Error('Unable to check availability. Please refresh the page.');
        const fresh = JSON.parse(freshEl.textContent);
        variantsData = fresh.variants;
        inventory = fresh.inventory;
        variant = variantsData.find(v => v.id === id);
        if (!variant || !variant.available || stockLimit(variant, inventory) <= 0) throw new Error('This size and color is now sold out. Please choose another option.');
        if ((findVariant() || {}).id !== id) throw new Error('Your selection changed. Please review it and try again.');
        const limit = stockLimit(variant, inventory);
        let inCart = 0;
        if (!checkout && Number.isFinite(limit)) {
          const cartResponse = await fetch(routeRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
          if (!cartResponse.ok) throw new Error('Unable to check your cart. Please try again.');
          const cart = await cartResponse.json();
          inCart = cart.items.filter(item => item.variant_id === id).reduce((sum, item) => sum + item.quantity, 0);
        }
        if (qty + inCart > limit) throw new Error('Only ' + limit + ' available' + (inCart ? ' (' + inCart + ' already in your cart)' : '') + '. Please reduce the quantity.');
        if (checkout) {
          // Preserve this theme’s direct checkout for the selected product only.
          window.location.href = routeRoot + 'cart/' + id + ':' + qty;
          return;
        }
        const added = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', body: data
        });
        const result = await added.json();
        if (!added.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        sessionStorage.setItem('openCartAfterReload', 'true');
        window.location.reload();
      } catch (error) {
        showError(error.message || 'Unable to complete your request. Please try again.');
      } finally {
        busy = false;
        syncPurchaseUI(findVariant());
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        purchase(false);
      }, { capture: true });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        purchase(true);
      });
    }

    /* --------------------------------------------------
       Mutually exclusive accordion panels
       -------------------------------------------------- */
    root.querySelectorAll('.mt-mdnmd-pd__accordion').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          root.querySelectorAll('.mt-mdnmd-pd__accordion').forEach(function (other) {
            if (other !== details) other.removeAttribute('open');
          });
        }
      });
    });
  }

  /* =====================================================
     DOM Ready：Find all  config  nodes and initialize them
     ===================================================== */

  function boot() {
    document.querySelectorAll('[data-mt-mdnmd-config]').forEach(function (el) {
      initInstance(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

})();
